import React, { useEffect, useState } from 'react';

const Preloader = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Hide the preloader after a certain period (e.g., 2 seconds)
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000); // Adjust the delay as needed
    return () => clearTimeout(timer); // Cleanup when the component unmounts
  }, []);

  if (loading) {
    return (
      <div className="preloader">
        <div className="preloader__image" style={{ backgroundImage: 'url("assets/logo.png")' }}></div>
      </div>
    );
  } else {
    return null;
  }
};

export default Preloader;
